<template>
    <table class="table table-sm table-hover" id="section_table">
        <thead class="thead-light">
            <tr>
                <th scope="col">#</th>
                <th scope="col">ID</th>
                <th scope="col">Name</th>
                <th scope="col"></th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(option, index) in list" :key="index">
                <th scope="row" class="section-cnt">{{ index + 1 }}</th>
                <td class="section-id">{{ option.id }}</td>
                <td class="section-name">{{ option.name }}</td>
                <td class="text-right">
                    <button v-on:click="selectItem(option)" v-visible="option.id !== selected" class="btn btn-sm btn-primary"><i class="fa fa-eye"></i></button>
              <!--      <button v-on:click="editItem(option)" class="btn btn-sm btn-secondary"><i class="fa fa-edit"></i></button> -->
                    <button class="section-edit-btn btn btn-sm btn-secondary" data-toggle="modal" data-target="#sectionEditModal" :data-id="option.id"><i class="fa fa-edit"></i></button>                    
                    <button v-on:click="removeItem(option)" class="btn btn-sm btn-danger"><i class="fa fa-trash"></i></button>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
export default {
    props: {
        list: Array,
        selected: null,
        selectedParent: null,
    },
    data() {
        return {};
    },
    methods: {
        selectItem(item) {
            this.$emit('select', item.id);
        },
        editItem(item) {
            this.$emit('edit', item);
                  	  this.button = 'Edit';    
        },
        removeItem(item) {
            if(confirm('Are you sure you want to delete this?')) {
                axios
                    .delete(this.sectionsUrl + '/' + item.id)
                    .then(res => {
                        this.$emit('remove', res.data);
                    });
            }
        },
    },
    computed: {
        sectionsUrl: function() {
            return '/event/stages/' + this.selectedParent + '/sections';
        }
    }
}
</script>